export const getRoundedValueOfCycleTime = (firstValue: number, secondValue: number): number => {
  return +(firstValue * secondValue).toFixed();
}